import type {Serializable, SerializedFunnelStep} from '../types/serialized-cohort-types';
import {BehaviorCount} from './behavior-count';

export class FunnelStep implements Serializable {
  constructor(public count: BehaviorCount, public value: number) {}

  public serialize(): SerializedFunnelStep {
    return {
      count: this.count.serialize(),
      value: this.value,
    };
  }
}
